import React from 'react';
import Article from '../../styled-components/Article';
import Hand from '../../styled-components/Hand';
import CenteredWrapper from '../../styled-components/CenteredWrapper';
import Description from '../../styled-components/Description';
import H2 from '../../styled-components/H2';
import P from '../../styled-components/P';

import trumpet from '../../img/trumpet.svg';
import montyPython from '../../img/monty-python-with-origin.svg';
import marked from 'marked';

class About extends React.Component {
  render() {
    const renderer = new marked.Renderer();
    renderer.link = ( href, title, text ) => `<a target="_blank" href="${ href }" title="${ title }">${ text }</a>`;
    const description = marked(this.props.description, { renderer:renderer });
    return (
      <Article absoluteBg style={{zIndex: 3}}>
        <Hand src={trumpet} top="-170px" right="0" hideOnMobile />
        <Hand src={montyPython} top="-40px" left="0" noMaxHeight hideOnMobile style={{width: '320px'}} />
        <H2 style={{zIndex: 2}}>{this.props.title}</H2>

        <CenteredWrapper withImage>
          <img src={this.props.image} />
          <Description dangerouslySetInnerHTML={{ __html: description}} />
        </CenteredWrapper>
      </Article>
    )
  }
};

export default About;



// WEBPACK FOOTER //
// ./src/components/About/index.js